import React, { useEffect, useRef } from "react";
import { animated, useSpring } from "react-spring";
import { Grid2 } from "@mui/material";

export const WelcomeFade: React.FC<{ text: string }> = text => {
  // Proper unmount check for LoadingAnimation component
  const isMountedRef = useRef(true);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  // @ts-ignore
  const styles = useSpring({
    opacity: 1,
    from: { opacity: 0 }
  });

  return (
    <Grid2
      container
      justifyContent={"center"}
      alignItems={"center"}
      sx={{ width: "100%", height: "100vh", textAlign: "center" }}
      data-testid="welcome-fade-anim-grid"
    >
      <animated.h1 style={styles as any}>{text.text}</animated.h1>
    </Grid2>
  );
};
